import React, { useEffect } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

export const PrevButton = props => {
  return <i className="arrow left" onClick={props.onClick}></i>;
};
export const NextButton = props => {
  return <i className="arrow right" onClick={props.onClick}></i>;
};
const Slide = props => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 5,
    arrows: true,
    centerMode: false,
    swipeToSlide: true,
    nextArrow: <NextButton />,
    prevArrow: <PrevButton />
  };
  const total = 5;
  const { listSlide, getDataCurrent, dataCurrent, title } = props;

  useEffect(() => {
    if (listSlide.length < 6) {
      const count = listSlide.length;

      for (let i = count; i < total; i++) {
        listSlide.push({});
      }
    }
  }, []);

  useEffect(() => {}, [listSlide]);

  return (
    <>
      <div className="slider-header">
        <div className="title">{title}</div>
      </div>
      <div className="slide-wrapper">
        <div className="slide-container">
          <Slider {...settings}>
            {listSlide?.map((item: any, index) => {
              return (
                <div key={index} className="slide-item">
                  <div className="background">
                    {item.id !== undefined ? (
                      <>
                        <img
                          onClick={() => {
                            getDataCurrent(item);
                          }}
                          src={item.imgSmall}
                          alt="digitalEmpireSmall1"
                        />
                        <div
                          className="overlay"
                          style={{
                            display: dataCurrent.id === item.id ? 'block' : 'none'
                          }}></div>
                      </>
                    ) : (
                      <div className="background"></div>
                    )}
                  </div>
                  <p>{item.name}</p>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Slide;
